//Core
import React from "react"

//Components
import InputSimple from "../../../components/InputSimple"

//UI
import Spinner from "../../../components/UI/Spinner"
import { onSucces, onFail } from "../../../components/UI/PopUp"

//Helpers
import { classes } from "../../../helpers/classname"

//Hooks
import useForm from "../../../FormHooks/referalHook"

//Style
import style from "./style.module.scss"

const { Container, Title, Wrapper, Button, FormWrapper, Grid } = style

const PudraForm = ({ link, product, source }) => {
  const { state, changeName, changePhone, onClick } = useForm(
    link,
    product,
    source
  )
  const { name, phone, fetch, success, fail } = state

  return fetch ? (
    <Spinner />
  ) : (
    <>
      <div id="form" className={classes(Container, Grid)}>
        <div className={classes(Wrapper, Grid)}>
          <h3 className={Title}>
            Замовляй #PudraCard зараз і вирушай на шопінг!
          </h3>
          <form
            className={classes(FormWrapper, Grid)}
            onSubmit={e => {
              e.preventDefault()
              onClick()
            }}
          >
            <InputSimple
              change={changeName}
              message={"Перевір правильність вводу імені"}
              checked={name.checked}
              placeholder={"Ім'я"}
              valid={name.valid}
              type="text"
              title={"Ім'я"}
            ></InputSimple>
            <InputSimple
              change={changePhone}
              change={changePhone}
              checked={phone.checked}
              valid={phone.valid}
              message={"Перевір правильність вводу номера мобільного телефону"}
              type="phone"
              title={"Телефон"}
            ></InputSimple>
            <button
              type="submit"
              onSubmit={e => e.preventDefault()}
              className={Button}
            >
              Замовити
            </button>
          </form>
        </div>
      </div>

      {success ? onSucces() : null}
      {fail ? onFail() : null}
    </>
  )
}

export default PudraForm
